import { useFetchContext } from "../../../common/FetchContext";
import { urls } from "../../../common/urls";
import { Role, RoleAccess, Row } from "./types";

const BASE_URL = (grid: string) => urls.reportWriterAgenda.reportGrid(grid);

const REPORT_GRID_INFO_URL = urls.reportWriterAgenda.reportGridInfo;

const ROLE_ENDPOINTS: Record<Role, string> = {
  writer: "writer",
  reviewer: "reviewer",
  verifier: "verifier",
  approver: "approver",
};

export const useAgendaApi = () => {
  const { authAxios } = useFetchContext();

  const fetchAgenda = async (endpoint: string): Promise<{ data: Row[] }> => {
    const response = await authAxios.get<Row[]>(BASE_URL(endpoint));

    return {
      data: response.data,
    };
  };

  const getWriterAgenda = () => fetchAgenda(ROLE_ENDPOINTS.writer);

  const getReviewerAgenda = () => fetchAgenda(ROLE_ENDPOINTS.reviewer);

  const getVerifierAgenda = () => fetchAgenda(ROLE_ENDPOINTS.verifier);

  const getApproverAgenda = () => fetchAgenda(ROLE_ENDPOINTS.approver);
  const getCompletedAgenda = () => fetchAgenda("completed");

  const getAgendaByRole = (role: Role) => {
    switch (role) {
      case "writer":
        return getWriterAgenda();

      case "reviewer":
        return getReviewerAgenda();

      case "verifier":
        return getVerifierAgenda();

      case "approver":
        return getApproverAgenda();

      default:
        return Promise.resolve({ data: [] });
    }
  };

  // Get role access/count information from API
  const getRolesAccess = async (): Promise<{
    data: RoleAccess[];
  }> => {
    try {
      const response = await authAxios.get<
        { roles: RoleAccess[] } | RoleAccess[]
      >(REPORT_GRID_INFO_URL);

      const payload = response.data;

      const roles = Array.isArray(payload) ? payload : (payload?.roles ?? []);

      return {
        data: roles,
      };
    } catch (error) {
      console.error("getRolesAccess error:", error);

      return {
        data: [],
      };
    }
  };

  return {
    getWriterAgenda,
    getReviewerAgenda,
    getVerifierAgenda,
    getApproverAgenda,
    getAgendaByRole,
    getCompletedAgenda,
    getRolesAccess,
  };
};
